import React from 'react'

const Tooltip = props => (
  <div className="tooltip-container" data-test="tooltipComponent"
    data-tooltip={props.tooltipcontent.props.children} >
    {props.children}
  </div>
)

export default Tooltip